function passwordValidator({ email }) {
  function minLength(value) {
    return value.length >= 8 || "Password must be at least 8 characters.";
  }

  function hasCaps(value) {
    return /[A-Z]/.test(value) || "Password must contain at least one uppercase letter.";
  }

  function hasNumber(value) {
    return /[0-9]/.test(value) || "Password must contain at least one number.";
  }

  function hasSpecialCharacter(value) {
    return (
      /[!@#$%^&*]/.test(value) ||
      "Password must contain at least one special character such as '*' or '#'."
    );
  }

  function doesNotContainEmail(value) {
    return !email || !value.includes(email) || "Password must not contain your email address.";
  }

  return {
    minLength,
    hasCaps,
    hasNumber,
    hasSpecialCharacter,
    doesNotContainEmail,
  };
}

function gradeConversionValidator() {
  return {
    isJSON: (value) => {
      try {
        return Boolean(JSON.stringify(JSON.parse(value)));
      } catch {
        return "Input must be valid JSON.";
      }
    },
  };
}

const makeupDaysIntervalValidator = (makeUpWorkEnabled) => (value) => {
  if (value === "") {
    if (makeUpWorkEnabled) return "This field is required if makeup work is enabled";
    return true;
  }
  if (Number(value) < 1 || Number(value) > 100) return "This field should be between 1 and 100.";
  if (Number(value) !== parseInt(value, 10)) return "This field should be an integer.";
};

export { passwordValidator, gradeConversionValidator, makeupDaysIntervalValidator };
